module.exports = __webpack_public_path__ + "img/img-3-6.9c47b9df.png";